<template>
	<div class="login-root">
		<div class="login-container">
			<div class="login-title"><img src="../../static/images/sclogo.jpg" alt="" /><span>{{ showType == 1?'四川创联国培职业技能等级认定中心':'海南创联国培职业技能等级认定中心'}}</span></div>
			<div class="login-form" @keyup.enter="doLogin">
				<label style="margin-top: 48px">
					<i class="fa fa-user-o fw" aria-hidden="true"><img src="../../static/images/usertx.png" /></i>
					<input type="text" v-model="username" placeholder="用户名" autofocus="autofocus" />
				</label>
				<label>
					<i class="fa fa-lock fw" aria-hidden="true"><img src="../../static/images/pswicon.png" /></i>
					<input type="password" v-model="password" placeholder="密码" />
				</label>
				<label for="">
                    <i class="fa fa-lock fw" aria-hidden="true"><img src="../../static/images/yamicon.png" /></i>
					<input type="验证码" v-model="yzm" placeholder="验证码" style="width: 278px" class="fl" />
					<a title="看不清，点一张" href="#" @click="refreshCode" style="display: block; width: 227px; height: 81px" class="fr">
						<img id="safecode" :src="yzmurl" alt="" style="margin-top: 10px; width: 200px" />
					</a>
				</label>
				<button @click="doLogin">登 录</button>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
p {
	color: white;
}

.login-root {
    position: fixed;
    left: 0;
    top: 0;
	text-align: center;
	width: 100%;
	height: 100%;
	background-image: url("../../static/images/loginbg.jpg");
    background-position: center;
    background-size: cover;
    min-height: 900px;
}
.login-container {
	width: 900px;
	margin: 0 auto;
	overflow: hidden;
    padding-top: 70px;
}
.login-container .login-title{
    width: 100%;
    font-size: 0;
    text-align: center;
}
.login-container .login-title img{
    display: inline-block;
    width: 40px;
    margin-right: 10px;
}
.login-container .login-title span {
    display: inline-block;
	font-size: 34px;
	color: #fff;
    line-height: 40px;
    vertical-align: top;
}

.login-form {
	box-sizing: border-box;
	width: 622px;
	border-radius: 4px;
	font-weight: lighter;
	margin: 0 auto;
	border-top: 1px solid #fff;
	margin-top: 83px;
	p {
		font-size: 26px;
		color: #20a0ff;
	}

	label {
		display: block;
		color: #ccc;
		font-size: 20px;
        position: relative;
	}

	i {
		font-size: 14px;
		top: 20px;
		left: 14px;
        position: absolute;
	}

	input {
		background: none;
		height: 79px;
		padding: 0 56px;
		margin-bottom: 28px;
		display: inline-block;
		width: 505px;
		color: #b3b3b3;
		font-size: 28px;
		border: none;
		outline: none;
		border: 1px solid #fff;
		&::placeholder {
			color: #8c939d;
		}
	}

	button {
		letter-spacing: 4px;
		outline: none;
		margin: 18px auto;
		height: 92px;
		width: 623px;
		border: none;
		background-color: #295e95;
		color: white;
		font-size: 35px;
		font-weight: lighter;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s;
		&:hover {
			background-color: #4db3ff;
		}
		&:active {
			background-color: #1d90e6;
		}
	}
}
</style>
<script>
import md5 from "js-md5";
export default {
	data() {
		return {
			username: "",
			password: "",
			yzm: "",
			yzmurl: "",
			showType: 1
		};
	},
	created() {
		var timenow = new Date().getTime();
		this.yzmurl = process.env.API_URL + "servlet/Image.Servlet?d=" + timenow;
	},
	mounted() {
		var domain = window.location.hostname
		// 1四川2海南
		if (domain == "hnjnrd.scjxjypx.com") {
			this.showType = 2
		}
	},
	methods: {
		checkValidity() {
			let isValid = true;

			if (!this.username || !this.password) {
				this.$message.error({ message: this.username ? "密码不能为空" : "用户名不能为空" });
				return false;
			}

			if (!/^[-a-zA-Z0-9_]{2,30}$/.test(this.username)) {
				this.$message.error({ message: "奇怪的用户名" });
				isValid = false;
			}

			if (this.password.legend < 3) {
				this.$message.error({ message: "密码长度太短" });
				isValid = false;
			}

			return isValid;
		},
		refreshCode() {
			var timenow = new Date().getTime();
			this.yzmurl = process.env.API_URL + "servlet/Image.Servlet?d=" + timenow;
		},
		doLogin() {
			if (!this.checkValidity()) {
				return;
			}
			this.$api.post("login/valid", { username: this.username, password: this.password, captcha: this.yzm }, (r) => {
				if (r.status == 0) {
					window.localStorage.setItem("username", this.username);
					this.$router.push({ path: "/main" });
				} else {
					this.$message.error({ message: r.message });
				}
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/views/login.vue